import { render } from "./video-item-skeleton.vue?vue&type=template&id=b298d680&scoped=true"
import script from "./video-item-skeleton.vue?vue&type=script&lang=js"
export * from "./video-item-skeleton.vue?vue&type=script&lang=js"

import "./video-item-skeleton.vue?vue&type=style&index=0&id=b298d680&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b298d680"]])

export default __exports__